module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-SemiBold.4f66f68c.woff2";